import { render } from "./AdminDate.vue?vue&type=template&id=5b6fadd2"
import script from "./AdminDate.vue?vue&type=script&lang=js"
export * from "./AdminDate.vue?vue&type=script&lang=js"

import "./AdminDate.vue?vue&type=style&index=0&id=5b6fadd2&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__